import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'customtime',
    standalone: false
})
export class CustomTimePipe implements PipeTransform {
  transform(value: string, format: string, _type: string = null): string {
    // Parse the time string and convert format from moment to Luxon
    const dt = DateTime.fromFormat(value, 'HH:mm:ss');
    
    // Convert moment format to Luxon format
    const luxonFormat = this.convertMomentToLuxonFormat(format);
    
    let result = dt.toFormat(luxonFormat);
    
    // Handle lowercase am/pm if the original format requested it with 'a' instead of 'A'
    if (format.includes('a') && !format.includes('A')) {
      result = result.replace('AM', 'am').replace('PM', 'pm');
    }
    
    return result;
  }
  
  private convertMomentToLuxonFormat(momentFormat: string): string {
    // Common moment to Luxon format conversions
    return momentFormat
      .replace(/A/g, 'a')           // AM/PM uppercase to lowercase
      .replace(/h/g, 'h')           // 12-hour format (already same)
      .replace(/H/g, 'H')           // 24-hour format (already same)
      .replace(/mm/g, 'mm')         // minutes (already same)
      .replace(/ss/g, 'ss')         // seconds (already same)
      .replace(/a/g, 'a');          // am/pm lowercase (already same)
  }
}
